import React from "react";
import { Result, Button } from "antd";
import userManager from "../../business/oidc/userManager";
import { Container, Left, Right } from "./Styled";

type LoginProps = {};

export const Login: React.FunctionComponent<LoginProps> = props => {
  return (
    <Container>
      <Left>
        <Result
          icon={<></>}
          title="Bon retour !"
          subTitle="C'est un plaisir de te revoir"
          extra={
            <Button type="primary" onClick={() => userManager.signinRedirect()}>
              Commencer
            </Button>
          }
        />
      </Left>
      <Right></Right>
    </Container>
  );
};

export default Login;
